import { Skeleton } from '@mui/material'

import { useMe } from 'src/hooks'
import { ListItem } from './list-item.component'

import { useStyles } from './styles'
import { IStripeCharge } from 'src/types'

interface IProps {
  transactions: IStripeCharge[]
  isLoading?: boolean
}

const BillingTransactionsList = ({ transactions, isLoading }: IProps) => {
  const { data: user } = useMe()
  const classes = useStyles()

  if (isLoading || !user) {
    return (
      <Skeleton width="100%" height="41px" sx={{ borderRadius: '10px' }} variant="rectangular" />
    )
  }

  return (
    <>
      <ul className={classes.invoicesList}>
        {transactions?.map((item) => (
          <ListItem
            user={user}
            created={item.created}
            id={item.id}
            amount={item.amount}
            invoice={item.invoice}
          />
        ))}
      </ul>
    </>
  )
}

export { BillingTransactionsList }
